import { ChatChannel } from "./ChatChannel";

export class ChatChannelEvent extends ChatChannel {
}